import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { base64string } from "../../../../utils/file-conversions-util";
import { LienTache } from "../../../../models/taches/gestion-taches.model";
import { FormateursService } from "../../../../services/formateurs/formateurs.service";
import { FormateurModel } from "../../../../models/formateurs/formateur.model";
import { PersonnesService } from "../../../../services/personnes/personnes.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-lien-formateur-details-tooltip',
  templateUrl: './lien-formateur-details-tooltip.component.html',
  styleUrls: ['./lien-formateur-details-tooltip.component.scss']
})
export class LienFormateurDetailsTooltipComponent implements OnInit {
  @Input() set lien(value: LienTache) {
    this.idFormateur = value.idOriginal;
    if (value) {
      this.loadPersonneDetails()
      this.loadPhoto()
    }
  }
  public formateur: FormateurModel;
  public photoData: base64string;
  public hideCancelled = false
  private idFormateur: number = null;
  public sub: Subscription[] = [];

  constructor(private formateurService: FormateursService, private personneService: PersonnesService) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.map(ob => ob.unsubscribe());
  }

  public hasEmail() : boolean {
    return this.formateur.email != null && this.formateur.email.length>0
  }

  get hasTelephone(): boolean {
    return (this.formateur.telephone != null && this.formateur.telephone.length>0)
  }

  private loadPersonneDetails() {
    this.sub.push(
      this.formateurService.getFormateurDetaille(this.idFormateur).subscribe(formateur => this.formateur = formateur)
    );
  }
  
  private loadPhoto() {
    this.sub.push(
      this.personneService.chargerPhotoAsBase64(this.idFormateur).subscribe(photoData => this.photoData = photoData)
    );
  }
}
